import HomeScreenBase from "../Base/Screens/Home/HomeScreenBase";
import { LoginScreen } from "../Base/Screens/Login/LoginScreen";

import ITRoutes from "./Routes/ITRoutes";
import SuministrosRoutes from "./Routes/SuministrosRoutes";
import GlobalRouter from "./Routes/GlobalRouter";
import { ComprasRouter } from "./Routes/ComprasRoutes";
import { MantenimientoRouter } from "./Routes/MantenimientoRouter"

import RequisasComprasReporte from "../Screen/ERP/Compras/Requisas/Reporte/RequisasComprasReporte";
import HomeScreen from "../Screen/ERP/Home/HomeScreen";
import OrdenesComprasReporte from "../Screen/ERP/Compras/OrdenesCompras/Reporte/OrdenesComprasReporte";
import RequisasMaterialesReporte from "../Screen/ERP/Suministros/Bodegas/RequisasMateriales/Reporte/RequisasMaterialesReporte";
import EtiquetaProducto from "../Screen/ERP/Global/Productos/Reporte/EtiquetaProducto";
import EtiquetaProductoQR from "../Screen/ERP/Global/Productos/Reporte/EtiquetaProductoQR";
import InscripcionProveedores from "../Screen/ERP/Compras/Proveedores/InscripcionProveedores";
import FormatoInscripcionPDF from "../Screen/ERP/Compras/Proveedores/FormatoInscripcion/FormatoInscripcion";
import RecursosHumanas from "./Routes/RecursosHumanosRouter";
import ActivosQR from "../Screen/ERP/Global/ActivosFijos/ActivosQR"
import Logistica from "./Routes/LogisticaRouter";
import MateriaPrima from "./Routes/MateriaPrimaRouter";
import Desarrollo from "./Routes/DesarrolloRoutes";
import Finanzas from "./Routes/FinanzasRoutes";
import VentasRouter from "./Routes/VentasRoutes";
import InscripcionClientes from "../Screen/ERP/Compras/Customers/InscripcionClientes";
import FormatoInscripcionClientes from "../Screen/ERP/Compras/Customers/FormatoInscripcionClientes";
import ActivosFijosScreen from "../Screen/ERP/Global/ActivosFijos/ActivosFijosScreen";
import IMEX from "./Routes/IMEXRouter";
import ConstruccionesEnProcesoScreen from "../Screen/ERP/Global/Construcciones/ConstruccionesEnProcesoScreen";


export const AppRoutes = {
  rutasOut: [
    {
      path: "login",
      element: <LoginScreen />,
    },
    {
      path: 'inscripcionProveedor/:lang/:Token',
      element: <InscripcionProveedores />
    },
    {
      path: 'FormatoInscripcionProveedor/:Numero/:Token/:Idioma',
      element: <FormatoInscripcionPDF /> 
    },
    {
      path: 'inscripcionClientes/:lang/:Token',
      element: <InscripcionClientes />
    },
    {
      path: 'FormatoInscripcionClientes/:IdCustomer/:Token/:Idioma',
      element: <FormatoInscripcionClientes />
    },
  ],
  rutasIn: [
    {
      path: 'PurchaseRequest/print/:IdReq/:Idioma',
      element: <RequisasComprasReporte/>
    },
    {
      path: 'OrdenCompras/print/:IdOrden/:Idioma',
      element: <OrdenesComprasReporte /> 
    },
    {
      path: 'RequisasMateriales/print/:IdRequisaM/:Idioma',
      element: <RequisasMaterialesReporte /> 
    },
    {
      path: 'EtiquetaProducto/print/:CodigoP/:Idioma',
      element: <EtiquetaProducto /> 
    },
    {
      path: 'EtiquetaProductoQR/print/:CodigoP/:Idioma',
      element: <EtiquetaProductoQR /> 
    },
    {
      path: 'InscripcionProveedor/:lang/:Token',
      element: <InscripcionProveedores />
    },
    {
      path: 'FormatoInscripcionProveedor/:Numero/:Token/:Idioma',
      element: <FormatoInscripcionPDF /> 
    },
    {
      path: 'EtiquetaActivoQR/print/:CodigoActivo',
      element: <ActivosQR /> 
    },
    {
      path: 'inscripcionClientes/:lang/:Token',
      element: <InscripcionClientes />
    },
    {
      path: 'FormatoInscripcionClientes/:IdCustomer/:Token/:Idioma',
      element: <FormatoInscripcionClientes />
    },
  ],
};

export const rutasDashboard = [
  
  // HOME
  {
    path: "Home",
    permiso: 2,
    element: <HomeScreenBase HomeScreen={HomeScreen} />,
  },
  
  {
    path: "Activos/ActivosFijos",
    permiso: 55,
    element: <ActivosFijosScreen Finanzas={false}/>,
  },

  {
    path: "Inventarios/ConstruccionesEnProceso",
    permiso: 117,
    element: <ConstruccionesEnProcesoScreen/>,
  },

  // {
  //   path: "Inventario/ActivosFijos",
  //   permiso: 55,
  //   element: <ActivosFijosScreen Finanzas={false}/>,
  // },

  // IT
  ...ITRoutes,

  // Suministros
  ...SuministrosRoutes,

  // Globales
  ...GlobalRouter,

  // Compras
  ...ComprasRouter,

  //Ventas
  ...VentasRouter,
  
  // Mantenimiento
  ...MantenimientoRouter,

  // Recuusos Humanos
  ...RecursosHumanas,

  // Logistica
  ...Logistica,

  // Logistica
  ...MateriaPrima,

  // Desarrollo
  ...Desarrollo,

  // Finanzas
  ...Finanzas,

  // IMEX
  ...IMEX,

];

// console.log("RUTAS DASHBOARD:", rutasDashboard);
